export const movieWorks = [
  {
    id: "m1",
    title: "无声告白",
    type: "movie",
    region: "中国大陆",
    year: 2026,
    rating: 8.3,
    genres: ["剧情", "家庭", "温情"],
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20film%20poster%2C%20a%20middle%20aged%20father%20and%20young%20daughter%20sitting%20side%20by%20side%20on%20a%20quiet%20pier%20at%20dusk%2C%20warm%20amber%20and%20soft%20crimson%20color%20grading%2C%20gentle%20bokeh%2C%20detailed%20digital%20painting%2C%20no%20text&width=600&height=800&seq=cp-movie-m1-cover&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=Serene%20wide%20view%20of%20a%20long%20wooden%20pier%20reaching%20into%20a%20calm%20sea%20under%20a%20warm%20amber%20dusk%20sky%2C%20soft%20haze%20and%20gentle%20bokeh%2C%20warm%20orange%20color%20grading%2C%20cinematic%20digital%20painting%2C%20no%20text&width=1600&height=900&seq=cp-movie-m1-hero&orientation=landscape",
    synopsis:
      "一封迟到二十年的信，让在外漂泊的摄影记者安然不得不回到久别的家。父亲已经病重，记忆时好时坏，却唯独记得她小时候最爱的那片海。为了完成父亲未竟的心愿，安然决定陪他重走一趟年轻时的旅程。一路上，那些没能说出口的告白，被一次次无声的行动悄悄说尽。",
    shortIntro:
      "一封迟到二十年的信，让漂泊在外的女儿回家，陪记忆时好时坏的父亲重走一趟年轻时的旅程。",
    cast: ["安然", "安建国", "李医生"],
    director: "徐怀山",
    releaseDate: "2026-01-16",
    totalEpisodes: 0,
    status: "已上映",
    heat: 7210,
    updatedAt: "2026-10-08",
    featured: true,
    highlight: "克制而深情的父女叙事，结尾一场海边长镜头被观众称为\"年度眼泪开关\"。",
    episodes: [],
  },
  {
    id: "m2",
    title: "时光代理人",
    type: "movie",
    region: "中国大陆",
    year: 2025,
    rating: 7.8,
    genres: ["科幻", "悬疑", "动作"],
    cover:
      "https://readdy.ai/api/search-image?query=Neo%20noir%20time%20travel%20film%20poster%2C%20a%20figure%20sprinting%20through%20a%20city%20street%20frozen%20in%20mid%20motion%2C%20glowing%20amber%20clock%20fragments%20in%20the%20air%2C%20warm%20orange%20and%20deep%20charcoal%20color%20grading%2C%20detailed%20digital%20painting%2C%20no%20text&width=600&height=800&seq=cp-movie-m2-cover&orientation=portrait",
    synopsis:
      "一家名为\"时光代理\"的神秘事务所，声称可以替客户修正人生中的关键选择。走投无路的程序员周屿找到这里，只想回到三年前阻止那场改变一切的意外。然而每一次\"修正\"都会引发新的连锁反应，他逐渐发现，代理人自己也被困在一个无法脱身的循环里。想要救回重要的人，周屿必须先弄明白：究竟是谁在替谁改变时间。",
    shortIntro:
      "走投无路的程序员找到能\"修正人生选择\"的神秘事务所，却发现每次改变都会引发新的连锁反应。",
    cast: ["周屿", "苏黎", "老陈"],
    director: "田一鸣",
    releaseDate: "2025-10-24",
    totalEpisodes: 0,
    status: "已上映",
    heat: 7650,
    updatedAt: "2026-10-05",
    highlight: "环环相扣的时间线设计，最后一幕的反转让人想立刻二刷。",
    episodes: [],
  },
  {
    id: "m3",
    title: "迷城追凶",
    type: "movie",
    region: "中国香港",
    year: 2025,
    rating: 8.1,
    genres: ["犯罪", "悬疑", "警匪"],
    cover:
      "https://readdy.ai/api/search-image?query=Gritty%20crime%20film%20poster%2C%20a%20detective%20silhouette%20in%20a%20rainy%20neon%20lit%20street%20at%20night%2C%20warm%20amber%20streetlights%20against%20dark%20shadows%2C%20reflective%20wet%20asphalt%2C%20detailed%20digital%20painting%2C%20no%20text&width=600&height=800&seq=cp-movie-m3-cover&orientation=portrait",
    synopsis:
      "连环失踪案的线索全部指向一座早已停工的旧城区。重案组督察方谋接手案件时，发现每一名失踪者都曾在同一张老照片里出现。随着调查深入，一桩被掩盖多年的旧案浮出水面。在这座被雨水浸透的城市里，真相与危险同样令人窒息，而凶手或许就站在离他最近的地方。",
    shortIntro:
      "连环失踪案线索指向一座停工旧城区，督察方谋发现每名失踪者都出现在同一张老照片里。",
    cast: ["方谋", "程雨", "麦警官"],
    director: "梁启锋",
    releaseDate: "2025-07-18",
    totalEpisodes: 0,
    status: "已上映",
    heat: 8020,
    updatedAt: "2026-09-26",
    highlight: "港式警匪片的凌厉节奏，雨夜追凶场面被赞\"找回老港片味道\"。",
    episodes: [],
  },
  {
    id: "m4",
    title: "长安夜行",
    type: "movie",
    region: "中国大陆",
    year: 2026,
    rating: 8.7,
    genres: ["古装", "动作", "悬疑"],
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20action%20film%20poster%2C%20a%20cloaked%20sword%20master%20standing%20on%20a%20rooftop%20overlook%20of%20a%20glowing%20ancient%20capital%20at%20night%2C%20warm%20lantern%20amber%20and%20crimson%20color%20grading%2C%20dramatic%20composition%2C%20detailed%20digital%20painting%2C%20no%20text&width=600&height=800&seq=cp-movie-m4-cover&orientation=portrait",
    heroImage:
      "https://readdy.ai/api/search-image?query=Panoramic%20night%20view%20over%20a%20glowing%20ancient%20Chinese%20capital%20with%20countless%20amber%20lanterns%2C%20rooftops%20and%20towers%20stretching%20to%20the%20horizon%2C%20crimson%20and%20amber%20color%20grading%2C%20cinematic%20digital%20painting%2C%20no%20text&width=1600&height=900&seq=cp-movie-m4-hero&orientation=landscape",
    synopsis:
      "长安城一夜之间连发七起命案，死者身上都留有一枚相同的墨印。戍卫校尉裴叙奉命彻查，却发现每条线索都通向十年前那场被史书轻描淡写的兵变。一夜之间，他要穿过整座城的灯火与暗巷，在天亮之前找出真凶。而当他终于接近答案时，才明白这一夜真正的猎物，从头到尾都是他自己。",
    shortIntro:
      "长安一夜连发七案，戍卫校尉裴叙彻查时发现线索皆指向十年前被掩埋的兵变真相。",
    cast: ["裴叙", "温九娘", "李少卿"],
    director: "程无咎",
    releaseDate: "2026-02-27",
    totalEpisodes: 0,
    status: "已上映",
    heat: 8910,
    updatedAt: "2026-10-12",
    featured: true,
    highlight: "动作设计行云流水，一夜追凶的紧凑结构加上史料考究的服化道，口碑爆棚。",
    episodes: [],
  },
  {
    id: "m5",
    title: "深海之光",
    type: "movie",
    region: "英国",
    year: 2025,
    rating: 7.6,
    genres: ["冒险", "剧情", "灾难"],
    cover:
      "https://readdy.ai/api/search-image?query=Deep%20sea%20adventure%20film%20poster%2C%20a%20submersible%20gliding%20through%20dark%20ocean%20depths%20illuminated%20by%20warm%20amber%20beacon%20light%2C%20bioluminescent%20particles%2C%20cinematic%20teal-free%20warm%20orange%20color%20grading%2C%20detailed%20digital%20painting%2C%20no%20text&width=600&height=800&seq=cp-movie-m5-cover&orientation=portrait",
    synopsis:
      "深海科考队在马里亚纳海沟执行一次例行勘探时，与母船失去了联系。有限的氧气、未知的海底地形，以及逐渐失灵的深海探测设备，让每一次下潜都成为生死考验。领队艾琳必须在队员的信任与任务的目标之间做出抉择。当微弱的光在深渊底部亮起，他们终于看见了那片从未被记录的海底。",
    shortIntro:
      "深海科考队与母船失联，氧气告急、设备失灵，领队艾琳必须在信任与目标之间做出抉择。",
    cast: ["艾琳", "托马斯", "娜奥米"],
    director: "奥利弗·格兰特",
    releaseDate: "2025-08-15",
    totalEpisodes: 0,
    status: "已上映",
    heat: 6540,
    updatedAt: "2026-09-12",
    highlight: "沉浸式深海音效与压迫感极强的摄影，大银幕观感惊人。",
    episodes: [],
  },
  {
    id: "m6",
    title: "末日余晖",
    type: "movie",
    region: "美国",
    year: 2026,
    rating: 7.9,
    genres: ["科幻", "剧情", "末世"],
    cover:
      "https://readdy.ai/api/search-image?query=Post%20apocalyptic%20sci-fi%20film%20poster%2C%20a%20lone%20traveler%20walking%20across%20a%20vast%20dust%20plain%20toward%20a%20huge%20setting%20amber%20sun%2C%20abandoned%20structures%20on%20the%20horizon%2C%20warm%20dusty%20orange%20color%20grading%2C%20detailed%20digital%20painting%2C%20no%20text&width=600&height=800&seq=cp-movie-m6-cover&orientation=portrait",
    synopsis:
      "太阳活动剧变后，地球只剩下最后一抹余晖。幸存者们躲进地下避难所，而年轻的通讯兵诺亚却选择回到地表，去寻找父亲留下的广播信号源。在荒芜的城市废墟与废弃的观测站之间，他遇见了同样在寻找什么的少女薇拉。两个孤独的人结伴前行，只为在光明彻底消失前，向外界发出最后一条讯息。",
    shortIntro:
      "末日之后年轻的通讯兵诺亚回到地表寻找信号源，与少女薇拉结伴，只为发出最后一条讯息。",
    cast: ["诺亚", "薇拉", "汉森"],
    director: "丹尼尔·科尔",
    releaseDate: "2026-03-06",
    totalEpisodes: 0,
    status: "已上映",
    heat: 7180,
    updatedAt: "2026-10-10",
    highlight: "末世美学与克制情感并存，配乐与摄影营造出诗意的孤独感。",
    episodes: [],
  },
];